import { useContext } from "react";
import { StoreyMeasuresContext } from "./storey-measures-context-props.ts";

const useStoreyMeasuresContext = () => {
    const context = useContext(StoreyMeasuresContext);
    if (!context) {
        throw new Error('Must be defined in StoreyMeasuresProvider');
    }
    return context;
}

export default useStoreyMeasuresContext;